import { Observable } from "rxjs"
import { ObservableFromFetch } from "../../ObservableFromFetch"
import ImportJobActionResult from "./Model/ImportJobActionResult"

export default function ImportJobCancelObservable(importJobID: number): Observable<ImportJobActionResult> {
  const params: string = JSON.stringify({ ImportJobID: importJobID })
  return ObservableFromFetch<ImportJobActionResult>("WorkforceImport/CancelImportJob", params)
}
